var $45e459e3b0ff81bd$exports = {};
window.requestAnimFrame = function() {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(a) {
        window.setTimeout(a, 1E3 / 60);
    };
}();
document.onselectstart = function() {
    return false;
};
var $45e459e3b0ff81bd$var$c = document.getElementById('c');
var $45e459e3b0ff81bd$var$ctx = $45e459e3b0ff81bd$var$c.getContext('2d');
var $45e459e3b0ff81bd$var$dpr = window.devicePixelRatio;
var $45e459e3b0ff81bd$var$cw = window.innerWidth;
var $45e459e3b0ff81bd$var$ch = window.innerHeight;
$45e459e3b0ff81bd$var$c.width = $45e459e3b0ff81bd$var$cw * $45e459e3b0ff81bd$var$dpr;
$45e459e3b0ff81bd$var$c.height = $45e459e3b0ff81bd$var$ch * $45e459e3b0ff81bd$var$dpr;
$45e459e3b0ff81bd$var$ctx.scale($45e459e3b0ff81bd$var$dpr, $45e459e3b0ff81bd$var$dpr);
var $45e459e3b0ff81bd$var$rand = function(rMi, rMa) {
    return ~~(Math.random() * (rMa - rMi + 1) + rMi);
};
$45e459e3b0ff81bd$var$ctx.lineCap = 'round';
var $45e459e3b0ff81bd$var$orbs = [];
var $45e459e3b0ff81bd$var$orbCount = 30;
var $45e459e3b0ff81bd$var$radius;
var $45e459e3b0ff81bd$var$trailCB = document.getElementById('trail');
var $45e459e3b0ff81bd$var$trail = $45e459e3b0ff81bd$var$trailCB.checked;
var $45e459e3b0ff81bd$var$clearer = document.getElementById('clear');
function $45e459e3b0ff81bd$var$createOrb(mx, my) {
    var dx = $45e459e3b0ff81bd$var$cw / 2 - mx;
    var dy = $45e459e3b0ff81bd$var$ch / 2 - my;
    var dist = Math.sqrt(dx * dx + dy * dy);
    var angle = Math.atan2(dy, dx);
    $45e459e3b0ff81bd$var$orbs.push({
        x: mx,
        y: my,
        lastX: mx,
        lastY: my,
        hue: 0,
        colorAngle: 0,
        angle: angle + Math.PI / 2,
        //size: .5+dist/250,
        size: $45e459e3b0ff81bd$var$rand(1, 3) / 2,
        centerX: $45e459e3b0ff81bd$var$cw / 2,
        centerY: $45e459e3b0ff81bd$var$ch / 2,
        radius: dist,
        speed: $45e459e3b0ff81bd$var$rand(5, 10) / 1000 * (dist / 750) + .015,
        alpha: 1 - Math.abs(dist) / $45e459e3b0ff81bd$var$cw,
        draw: function() {
            $45e459e3b0ff81bd$var$ctx.strokeStyle = 'hsla(' + this.colorAngle + ',100%,50%,1)';
            $45e459e3b0ff81bd$var$ctx.lineWidth = this.size;
            $45e459e3b0ff81bd$var$ctx.beginPath();
            $45e459e3b0ff81bd$var$ctx.moveTo(this.lastX, this.lastY);
            $45e459e3b0ff81bd$var$ctx.lineTo(this.x, this.y);
            $45e459e3b0ff81bd$var$ctx.stroke();
        },
        update: function() {
            var mx = this.x;
            var my = this.y;
            this.lastX = this.x;
            this.lastY = this.y;
            var x1 = $45e459e3b0ff81bd$var$cw / 2;
            var y1 = $45e459e3b0ff81bd$var$ch / 2;
            var x2 = mx;
            var y2 = my;
            var rise = y1 - y2;
            var run = x1 - x2;
            var slope = -(rise / run);
            var radian = Math.atan(slope);
            var angleH = Math.floor(radian * (180 / Math.PI));
            if (x2 < x1 && y2 < y1) angleH += 180;
            if (x2 < x1 && y2 > y1) angleH += 180;
            if (x2 > x1 && y2 > y1) angleH += 360;
            if (y2 < y1 && slope == '-Infinity') angleH = 90;
            if (y2 > y1 && slope == 'Infinity') angleH = 270;
            if (x2 < x1 && slope == '0') angleH = 180;
            if (isNaN(angleH)) angleH = 0;
            this.colorAngle = angleH;
            this.x = this.centerX + Math.sin(this.angle * -1) * this.radius;
            this.y = this.centerY + Math.cos(this.angle * -1) * this.radius;
            this.angle += this.speed;
        }
    });
}
function $45e459e3b0ff81bd$var$orbGo(e) {
    var mx = e.pageX - $45e459e3b0ff81bd$var$c.offsetLeft;
    var my = e.pageY - $45e459e3b0ff81bd$var$c.offsetTop;
    $45e459e3b0ff81bd$var$createOrb(mx, my);
}
function $45e459e3b0ff81bd$var$turnOnMove() {
    $45e459e3b0ff81bd$var$c.addEventListener('mousemove', $45e459e3b0ff81bd$var$orbGo, false);
}
function $45e459e3b0ff81bd$var$turnOffMove() {
    $45e459e3b0ff81bd$var$c.removeEventListener('mousemove', $45e459e3b0ff81bd$var$orbGo, false);
}
function $45e459e3b0ff81bd$var$toggleTrails() {
    $45e459e3b0ff81bd$var$trail = $45e459e3b0ff81bd$var$trailCB.checked;
}
function $45e459e3b0ff81bd$var$clear() {
    $45e459e3b0ff81bd$var$orbs = [];
}
$45e459e3b0ff81bd$var$c.addEventListener('mousedown', $45e459e3b0ff81bd$var$orbGo, false);
$45e459e3b0ff81bd$var$c.addEventListener('mousedown', $45e459e3b0ff81bd$var$turnOnMove, false);
$45e459e3b0ff81bd$var$c.addEventListener('mouseup', $45e459e3b0ff81bd$var$turnOffMove, false);
$45e459e3b0ff81bd$var$trailCB.addEventListener('change', $45e459e3b0ff81bd$var$toggleTrails, false);
$45e459e3b0ff81bd$var$clearer.addEventListener('click', $45e459e3b0ff81bd$var$clear, false);
var $45e459e3b0ff81bd$var$count = 100;
while($45e459e3b0ff81bd$var$count--)$45e459e3b0ff81bd$var$createOrb($45e459e3b0ff81bd$var$cw / 2, $45e459e3b0ff81bd$var$ch / 2 + $45e459e3b0ff81bd$var$count * 2);
var $45e459e3b0ff81bd$var$loop = function() {
    window.requestAnimFrame($45e459e3b0ff81bd$var$loop);
    if ($45e459e3b0ff81bd$var$trail) {
        $45e459e3b0ff81bd$var$ctx.fillStyle = 'rgba(0,0,0,.1)';
        $45e459e3b0ff81bd$var$ctx.fillRect(0, 0, $45e459e3b0ff81bd$var$cw, $45e459e3b0ff81bd$var$ch);
    } else $45e459e3b0ff81bd$var$ctx.clearRect(0, 0, $45e459e3b0ff81bd$var$cw, $45e459e3b0ff81bd$var$ch);
    var i = $45e459e3b0ff81bd$var$orbs.length;
    while(i--){
        var orb = $45e459e3b0ff81bd$var$orbs[i];
        var updateCount = 3;
        while(updateCount--){
            orb.update();
            orb.draw($45e459e3b0ff81bd$var$ctx);
        }
    }
};
$45e459e3b0ff81bd$var$loop();


//# sourceMappingURL=index.e9682c79.js.map
